import { RuntimeScopeQuery, StepRunScopeQuery } from '@/types/stepExecutions.ts';

export const getStepRunScopeKeyParts = (scope?: StepRunScopeQuery) =>
  [scope?.parentPath ?? '', scope?.childIndex ?? null, scope?.attemptNumber ?? null, scope?.scopeParentStepRunId ?? ''] as const;

export const getStepRunScopeQueryParams = (scope?: StepRunScopeQuery) => ({
  parent_path: scope?.parentPath,
  child_index: scope?.childIndex,
  attempt_number: scope?.attemptNumber,
  scope_parent_step_run_id: scope?.scopeParentStepRunId,
});

export const getRuntimeScopeKeyParts = (scope?: RuntimeScopeQuery) =>
  [scope?.parentPath ?? '', scope?.childIndex ?? null, scope?.scopeParentStepRunId ?? ''] as const;

export const getRuntimeScopeQueryParams = (scope?: RuntimeScopeQuery) => ({
  parent_path: scope?.parentPath,
  child_index: scope?.childIndex,
  scope_parent_step_run_id: scope?.scopeParentStepRunId,
});
